import {create} from "zustand";

interface sexTypeState {
  sexValue: number;
  disabledSex: boolean;
  sexString: string;
  setSexValue: (value: number) => void;
  setDisabledSex: (value: boolean) => void;
  setSexString: (value: string) => void;
  sexList: string[];
  sexCompValue: number[];
  setSexCompValue: (value: number[]) => void;
}

const useSexType = create<sexTypeState>((set) => ({
  sexValue: 0,
  disabledSex: false,
  sexString: "females and males",
  setSexValue: (value) => set((state) => ({sexValue: value})),
  setDisabledSex: (value) => set((state) => ({disabledSex: value})),
  setSexString: (value) => set((state) => ({sexString: value})),
  sexList: ["All", "Female", "Male"],
  sexCompValue: [0, 1],
  setSexCompValue: (value: number[]) => set(() => ({sexCompValue: value})),
}));
export default useSexType;
